import { createRoute, Navigate } from '@tanstack/react-router';
import LoadingScreen from 'components/LoadingScreen';
import { useRegionalDirectorIdsFilter } from 'hooks/useRegionalDirectorIdsFilter';
import MainLayout from 'layouts/dashboard/MainLayout';
import { rootRoute } from 'routes/rootRoute';
import { canAccessLabPages, WithEnsure, WithExpiredFeatureCheck } from 'routes/routeUtils';

export const labParentRoute = createRoute({
  getParentRoute: () => rootRoute,
  component: () => WithEnsure(canAccessLabPages, <MainLayout />),
  path: '/lab',
  pendingComponent: LoadingScreen,
});

export const labExpiredParentRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/expired_products_requests',
  component: () => <WithExpiredFeatureCheck />,
});

export const labIndexRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/',
  component: () => {
    const regionalDirectorIds = useRegionalDirectorIdsFilter();
    return (
      <Navigate
        to="/lab/trades/list"
        search={{ regionalDirectorIds, tab: 'awaiting_validation_by_lab' }}
      />
    );
  },
});
